<aside class="sidebar" [class.sidebar--collapsed]="collapsed()">
  <div class="sidebar__brand">
    <div class="sidebar__brand-mark">
      <img src="assets/images/zenbasket-analytics-logo.png" alt="ZenBasket Analytics Logo" />
    </div>
    <span class="sidebar__brand-name">Zen Analytics</span>
  </div>

  <nav class="sidebar__nav" aria-label="Primary navigation">
    @for (section of navSections; track section.sectionLabel) {
    <div class="sidebar__section-label">{{ section.sectionLabel }}</div>
    @for (item of section.items; track item.label) {
    @if (!item.children) {
    <!-- Regular navigation item without submenu -->
    <a class="sidebar__item" [routerLink]="item.route" routerLinkActive="is-active" (click)="onNavItemClick()"
      [title]="item.title || item.label">
      <i class="bi" [class]="item.icon"></i>
      <span>{{ item.label }}</span>
    </a>
    } @else {
    <div class="sidebar__parent-group">
      <button class="sidebar__item sidebar__item--parent" [class.is-expanded]="isMenuExpanded(item)"
        [class.is-active-child]="isParentWithActiveChild(item)" (click)="toggleMenu(item)"
        [attr.aria-expanded]="isMenuExpanded(item)" [title]="item.title || item.label" type="button">
        <i class="bi" [class]="item.icon"></i>
        <span>{{ item.label }}</span>
        <i class="bi sidebar__item--chevron" [class.bi-chevron-right]="!isMenuExpanded(item)"
          [class.bi-chevron-down]="isMenuExpanded(item)"></i>
      </button>

      @if (isMenuExpanded(item)) {
      <div class="sidebar__submenu" [attr.aria-label]="item.label">
        @for (child of item.children; track child.route) {
        <a class="sidebar__item sidebar__item--child" [routerLink]="child.route" routerLinkActive="is-active"
          (click)="onNavItemClick()" [title]="child.title || child.label">
          <i class="bi" [class]="child.icon"></i>
          <span>{{ child.label }}</span>
        </a>
        }
      </div>
      }
    </div>
    }
    }
    }
  </nav>
</aside>